/**
 * This Javascript module is used for markup within the database
 */

export default {
  init: function()
  {
    if (!$('.wpforms-container ').length)
    {
      return;
    }
    this.initForm();
  },

  initForm: function()
  {
    var THIS = this;
    $('.wpforms-container select').wrap('<div class="wpforms-field-select-wrapper"></div>').after('<i class="fa fa-chevron-down" aria-hidden="true"></i>');
  }

}